export enum ErrorType {
  PDFDownload = 'PDF Download',
  FlagsUnconfigured = 'Unconfigured Feature Flags',
  FlagsMissingInAPI = 'Feature Flags missing in API',
  FlagsToRemove = 'Feature Flags to remove',
}
